// extracted by mini-css-extract-plugin
export var input = "file-input-area-module--input--e498c";
export var label = "file-input-area-module--label--47a7d";